import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PestControlRodentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pest_control_rodent"}/>
}
